/* eslint-disable import/prefer-default-export */

export const scenariosSideNavWidthInPixels = 320
